module.exports = __webpack_public_path__ + "static/media/acy_logo.4da2e5e5.svg";